import { MENUTREE } from '../../../../config/ui-config';

export const MENU_TREE: any = MENUTREE;
